import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import CollapseIndicator from 'components/indicators/collapse-indicator';
import Subcategories from 'modules/budget/components/category/category-table/subcategories';
import DeleteButton from 'modules/budget/components/category/category-table/delete-button';
import EditButton from 'modules/budget/components/category/category-table/edit-button';
import AddSubcategoryButton from 'modules/budget/components/category/category-table/add-subcategory-button';
import HideButton from 'modules/budget/components/category/category-table/hide-button';

@withNamespaces()
@observer
class ParentCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: true,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState((state) => ({open: !state.open}));
    }

    render() {
        const { open } = this.state;
        const { t, category, hidden } = this.props;
        const { id, name, custom, categories } = category;
        const hasChildren = category.categories.length > 0;

        return (
            <Fragment>
                <tr id={`parent-category-${id}`}>
                    <td onClick={this.toggle}>
                        <CollapseIndicator open={open} />
                        {t(name)}
                        &nbsp;
                        {!hidden && <AddSubcategoryButton parentCategory={category} />}
                    </td>
                    <td className="text-right">
                        <div className="btn-group">
                            {(!hasChildren || hidden) && <HideButton category={category} hidden={hidden} />}
                            {custom && !hidden && (
                                <Fragment>
                                    <EditButton category={category} />
                                    {!hasChildren && <DeleteButton category={category} />}
                                </Fragment>
                            )}
                        </div>
                    </td>
                </tr>
                {open && <Subcategories categories={categories} hidden={hidden} />}
            </Fragment>
        )
    }
}

ParentCategory.propTypes = {
    /** ParentCategory object reference from the store */
    category: PropTypes.any.isRequired,

    /** Whether this component is displaying hidden categories */
    hidden: PropTypes.bool,
};

export default ParentCategory;


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/parent-category.js